// extracted by mini-css-extract-plugin
export var divider = "_ub-0";
export var systemMessage = "_ub-1";